<template>
    <v-form v-model="formData.isValid">
        <v-row>
            <v-col cols="12">
                <v-card outlined>
                    <v-card-title>Deine Daten</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="personalData.mandator.prename" label="Vorname" :rules="validationRules.defaultNotNull"/>
                        <v-text-field v-model="personalData.mandator.surname" label="Nachname" :rules="validationRules.defaultNotNull"/>
                        <v-text-field v-model="personalData.mandator.street" label="Straße" :rules="validationRules.defaultNotNull"/>
                        <v-text-field v-model="personalData.mandator.house_number" label="Hausnummer" :rules="validationRules.defaultNotNull"/>
                        <v-text-field v-model="personalData.mandator.zip" label="PLZ" :rules="validationRules.zip"/>
                        <v-text-field v-model="personalData.mandator.city" label="Stadt" :rules="validationRules.defaultNotNull"/>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" v-for="(fellowPassenger, index) in personalData.fellowPassengers" :key="index">
                <v-card outlined>
                    <v-card-title>
                        Daten Mitreisender Nr. {{index + 1}}
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="fellowPassenger.prename" label="Vorname" :rules="validationRules.defaultNotNull"/>
                        <v-text-field v-model="fellowPassenger.surname" label="Nachname" :rules="validationRules.defaultNotNull"/>
                        <v-text-field v-model="fellowPassenger.street" label="Straße" :rules="validationRules.defaultNotNull"/>
                        <v-text-field v-model="fellowPassenger.house_number" label="Hausnummer" :rules="validationRules.defaultNotNull"/>
                        <v-text-field v-model="fellowPassenger.zip" label="PLZ" :rules="validationRules.zip"/>
                        <v-text-field v-model="fellowPassenger.city" label="Stadt" :rules="validationRules.defaultNotNull"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn rounded color="secondary" @click.stop="removeFellowPassenger(index)">Mitreisenden entfernen</v-btn>
                        <v-spacer/>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12">
                Wenn du Mitreisende einträgst, musst du bevollmächtigt sein die Entschädigung für diese Mitreisenden einzufordern.
                Auf Wunsch der Fluglinie musst du unter Umständen eine von den Mitreisenden unterschriebene Bestätigung nachreichen.
            </v-col>
            <v-col cols="12" md="4" offset-md="4">
                <v-btn
                    block
                    color="primary"
                    @click.stop="addFellowPassenger"
                    rounded
                >
                    Mitreisenden hinzufügen
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card outlined>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="personalData.mandator.mail"
                                    label="Deine E-Mail Adresse"
                                    persistent-hint
                                    hint="Wir benötigen sie für die Antwort der Fluggesellschaft."
                                    :rules="validationRules.email"
                                />
                                <v-text-field
                                    v-model="personalData.mandator.phone"
                                    label="Telefonnummer"
                                    :rules="validationRules.telephone"
                                />
                                <v-select
                                    v-if="hasRSV"
                                    v-model="personalData.rsv_id"
                                    :items="rsvs"
                                    label="Rechtsschutzversicherung"
                                    :rules="validationRules.defaultNotNull"
                                    item-value="id"
                                    item-text="name"
                                />
                                <v-checkbox
                                    v-model="viewData.hasReplacementExpense"
                                    label="Ich hatte Zusatzkosten für ein Ersatzticket (weil z. B. bei Annullierung des Fluges kein Ersatzflug angeboten wurde)"
                                />
                                <v-currency-field
                                    v-if="viewData.hasReplacementExpense"
                                    v-model="replacementTicket"
                                    label="Zusatzkosten für ein Ersatzticket"
                                    prefix="€"
                                    :rules="validationRules.defaultNotNull"
                                />
                                <v-text-field v-model="personalData.mandator.iban" label="IBAN" :rules="validationRules.iban"/>
                                <v-text-field v-model="personalData.mandator.bic" label="BIC" :rules="validationRules.bic"/>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import {hasMinLength, isEmail, isNotNull, isNumeric} from "@/helper/ValidationHelper";
import IBAN from 'iban';

export default {
    props: {
        hasRSV: {
            type: Boolean,
            default: false
        },
        rsvs: {
            type: Array,
            default: function()
            {
                return [];
            }
        }
    },
    emits: ['validity-changed', 'form-data-changed'],
    computed: {
        replacementTicket: {
            get: function() {
                if(this.personalData.expenses.length > 0)
                    return this.personalData.expenses[0].value;

                return null;
            },
            set: function(newValue) {
                this.personalData.expenses[0].value = newValue;
            }
        }
    },
    data: () => ({
        constants: {
            EXPENSE_TYPE_REPLACEMENT_TICKET: 0
        },
        formData: {
            isValid: false
        },
        validationRules: {
            defaultNotNull: [
                isNotNull
            ],
            iban: [
                v => IBAN.isValid(v) || 'Bitte geben Sie eine gültige IBAN ein.'
            ],
            bic: [
                v => /^[a-z]{6}[2-9a-z][0-9a-np-z]([a-z0-9]{3}|x{3})?$/i.test(v) || 'Bitte geben Sie einen gültigen BIC ein.'
            ],
            email: [
                isEmail
            ],
            zip: [
                v => hasMinLength(v, 5),
                isNumeric,
                isNotNull
            ],
            telephone: [
                v => hasMinLength(v, 5),
                isNumeric,
                isNotNull
            ]
        },
        viewData: {
            hasReplacementExpense: false
        },
        personalData: {
            mandator: {
                lawform: null,
                prename: null,
                surname: null,
                street: null,
                house_number: null,
                zip: null,
                city: null,
                mail: null,
                phone: null,
                iban: null,
                bic: null
            },
            fellowPassengers: [],
            expenses: [],
            rsv_id: null
        }
    }),
    methods: {
        addFellowPassenger()
        {
            this.personalData.fellowPassengers.push({
                lawform: null,
                prename: null,
                surname: null,
                street: null,
                house_number: null,
                zip: null,
                city: null
            });
        },
        removeFellowPassenger(index)
        {
            this.personalData.fellowPassengers.splice(index, 1);
        }
    },
    watch: {
        'viewData.hasReplacementExpense': function(newValue)
        {
            if(newValue === false)
                this.personalData.expenses = [];
            else
            {
                this.personalData.expenses.push({
                    type: this.constants.EXPENSE_TYPE_REPLACEMENT_TICKET,
                    value: null
                });
            }
        },
        'formData.isValid': function(newValue)
        {
            this.$emit('validity-changed', newValue);
        },
        personalData:
        {
            handler: function(flightData)
            {
                this.$emit('form-data-changed', flightData);
            },
            deep: true
        },
        hasRSV: function(newValue, oldValue)
        {
            if(oldValue && (newValue === false))
                this.personalData.rsv_id = null;
        }
    }
}
</script>

<style scoped>

</style>
